import React from 'react';

// helpers
import {useTranslation} from 'react-i18next';
import {formatCurrency} from '../../helpers';

// styles
import {
  TableWrapper,
  TableHeaderItem,
  ActionColumnHeaderItem,
  TableRow,
  ActionButtonWrapper,
  DeferButton,
} from './Table-styles';
import {TextDefault, TextSmall} from '../../styles';

// types
import {LoanPayment} from '../../services/ApiService/types';

type Props = {
  payments: LoanPayment[];
  onDeferPaymentClick: (e: React.MouseEvent, payment: LoanPayment) => void;
  isVariableCredit: boolean | undefined;
};

const TablePaymentsLoan = ({payments, isVariableCredit, onDeferPaymentClick}: Props) => {
  const {t} = useTranslation();

  return (
    <TableWrapper borderAxis="none">
      <thead>
        <tr>
          <TableHeaderItem>
            <TextDefault bold="bold">
              {t('loan_payment_paymentNumber')}
            </TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">{t('global_date')}</TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">{t('global_status')}</TextDefault>
          </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">
              {t('loan_payment_paymentAmount')}
            </TextDefault>
          </TableHeaderItem>
          {isVariableCredit &&
              <TableHeaderItem>
                <TextDefault bold="bold">
                  {t('loan_payment_membership_fee')}
                </TextDefault>
              </TableHeaderItem>
            }
          <TableHeaderItem>
            <TextDefault bold="bold">
              {t('loan_payment_transaction_fee')}
            </TextDefault>
          </TableHeaderItem>
            <TableHeaderItem>
              <TextDefault bold="bold">
                {t('loan_payment_total_payment_amount')}
              </TextDefault>
            </TableHeaderItem>
          <TableHeaderItem>
            <TextDefault bold="bold">{t('loan_payment_balance')}</TextDefault>
          </TableHeaderItem>
          <ActionColumnHeaderItem />
        </tr>
      </thead>
      <tbody>
        {payments.map((payment) => (
          <TableRow key={payment.id}>
            <td>
              <TextSmall>#{payment.paymentNumber}</TextSmall>
            </td>
            <td>
              <TextSmall>{payment.paymentDate}</TextSmall>
            </td>
            <td>
              <TextSmall>{payment.status}</TextSmall>
            </td>
            <td>
              <TextSmall>{formatCurrency(payment.amount)}</TextSmall>
            </td>
            {isVariableCredit && 
                <>
                  <td>
                    <TextSmall>{formatCurrency(payment.membershipFee)}</TextSmall>
                  </td>
                </>
              }
              <td>
                <TextSmall>{formatCurrency(payment.transactionFee)}</TextSmall>
              </td>
              <td>
                <TextSmall>{formatCurrency(payment.paymentAmount ?? 0)}</TextSmall>
              </td>
               <td>
                  <TextSmall>{formatCurrency(payment.balance)}</TextSmall>
              </td>
            <ActionButtonWrapper>
              {payment.canBeDeferred && (
                <DeferButton
                  variant="outlined"
                  onClick={(e) => onDeferPaymentClick(e, payment)}>
                  {t('loan_payment_defer')}
                </DeferButton>
              )}
            </ActionButtonWrapper>
          </TableRow>
        ))}
      </tbody>
    </TableWrapper>
  );
};

export default TablePaymentsLoan;
